import React from "react";
import moment from "moment";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as recipeReducer from "containers/Recipe/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as transformReducer from "containers/Dataset/reducer";
import * as nextReducer from "containers/Next/NextReducer";

import { getProjectID, getProjectDatasets, getCreatingProject } from "containers/ConsultingProjects/reducer";
import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";
import { getIsEDG } from "containers/Gallery/GalleryReducer";
import { getIsDataLink } from "containers/SchemaMonitor/reducer";

import DatasetItem from "containers/View/Item/DatasetItem";
import RecipeItem from "containers/View/Item/RecipeItem";

import EmptyTile from "components/Tiles/EmptyTile";
import EmptyNotice from "components/View/EmptyNotice";
import UploadModal from "components/View/UploadModal";

import Overview from "components/Tiles/Overview/Overview";
import ViewMessage from "components/View/ViewMessage";

import * as schemaMonitorReducer from "containers/SchemaMonitor/reducer";
import * as dataSourceSummariesReducer from "containers/DataSourceSummaries/reducer";
import * as nextOverviewReducer from "containers/Next/Overview/OverviewReducer";

import { isEnabled } from "utils/featureFlags";

class OverviewViewContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showUploadModal: false,
      isLinkMode: false,
      uploadUrl: undefined
    };

    props.initDataSourceSummary();
  }

  setModal(value = false) {
    return this.setState({
      showUploadModal: value,
      uploadUrl: undefined,
      shellDatasetName: undefined,
      shellDatasetDescription: undefined
    });
  }

  handleFile(event) {
    const { handleFileChange, validateFileExtension } = this.props;

    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    if (validateFileExtension(file)) {
      this.setModal(false);
      return handleFileChange(file, event.currentTarget);
    }
  }

  createShellDataset(name) {
    const { handleFileChange } = this.props;

    // create dummy file - not actually uploaded
    const blob = new Blob(["1"], { type: "text/plain" });
    const file = new File([blob], name, { type: blob.type });

    this.setState({ uploadUrl: "Creating..." });

    return handleFileChange(
      file,
      {},
      {
        skipUpload: true,
        description: this.state.shellDatasetDescription
      }
    ).then((dataset) => this.setState({ uploadUrl: dataset.metadata.upload_url }));
  }

  handleImportRecipeTrigger() {
    const { importRecipeId, executeRecipeImport, linkBlueprintToRecipeVersionInstance } = this.props;
    this.setState({
      isImportRecipeCreating: true
    });

    executeRecipeImport(importRecipeId, () => {
      this.setState({ isImportRecipeCreating: false });
    }).then((recipeVersionInstance) => linkBlueprintToRecipeVersionInstance(recipeVersionInstance.id));
  }

  renderLoading() {
    return <LoadingIndicator />;
  }

  render() {
    const { data, selectedAccountId, isLoading } = this.props;

    const { showUploadModal } = this.state;

    return isLoading ? (
      this.renderLoading()
    ) : (
      <React.Fragment>
        <Overview
          {...this.props}
          datasets={data}
          uploadCSV={() => this.setModal(true)}
          handleClick={(dataset) => console.log("dclick", dataset)}
        />
        <div style={{ display: "none" }}>
          <input type="file" ref="file" id="fUpload" onChange={(e) => this.handleFile(e)} />
        </div>
        <UploadModal
          show={showUploadModal}
          selectedAccountId={selectedAccountId}
          handleClose={() => this.setModal(false)}
          handleUpload={() => document.getElementById("fUpload").click()}
          uploadUrl={this.state.uploadUrl}
          handleCreateShellDataset={() => this.createShellDataset(this.state.shellDatasetName)}
          shellDatasetName={this.state.shellDatasetName}
          updateShellDatasetName={(x) => this.setState({ shellDatasetName: x })}
          shellDatasetDescription={this.state.shellDatasetDescription}
          updateShellDatasetDescription={(x) => this.setState({ shellDatasetDescription: x })}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  validateFileExtension: (file, extension) => uploadReducer.validateFileExtension(file, extension),
  handleFileChange: (file, target, additionalOptions) =>
    dispatch(uploadReducer.handleFileChange(file, target, additionalOptions)),
  setDatasetTarget: (datasetId, target, success) => dispatch(homeReducer.setDatasetTarget(datasetId, target, success)),

  handleTableauUpload: () => dispatch(loginReducer.handleTableauUpload()),
  executeRecipeImport: (recipeId, onComplete) => dispatch(recipeReducer.executeRecipeImport(recipeId, onComplete)),

  updateIsSchemaLinkMode: (show) => dispatch(schemaMonitorReducer.updateIsShowModal(show)),
  openAndSelectSchema: (schemaMonitorId) => dispatch(schemaMonitorReducer.openAndSelectSchema(schemaMonitorId)),
  updateIsLinkMode: (show) => dispatch(viewReducer.updateIsLinkMode(show)),
  updateIsBoomiLinkMode: (show) => dispatch(viewReducer.updateIsBoomiLinkMode(show)),

  initDataSourceSummary: () => dispatch(dataSourceSummariesReducer.init()),
  overviewSearch: (overviewData) => dispatch(nextOverviewReducer.overviewSearch(overviewData))
});

const mapStateToProps = (state, ownProps) => {
  const accounts = accountsReducer.getAccounts(state);

  return {
    isTile: viewReducer.getIsTile(state),
    datasetViewMode: viewReducer.getDatasetViewMode(state),
    data: [],
    isImportRecipeExecuting:
      recipeReducer.getRecipeVersionInstanceStatusByBlueprintId(state, ownProps.blueprintId) ==
      recipeReducer.RecipeVersionInstanceStatus.Running,
    isTabUploading: loginReducer.getIsTabUploading(state),
    isDataUploading: globalReducer.getIsDataUploading(state),
    isDatasetsLoading: globalReducer.getIsDatasetsLoading(state),
    useUploadModal: isEnabled("dataset-upload") || (accounts && accounts.length > 1),
    selectedAccountId: accountsReducer.getSelectedAccountId(state),
    account: accountsReducer.getSelectedAccount(state),
    accounts: accountsReducer.getActiveAccounts(state),
    schemaMonitors: schemaMonitorReducer.getSchemaMonitors(state),

    overviewItem: viewReducer.getOverviewItem(state),
    activityData: viewReducer.getActivityData(state),

    headerMode: viewReducer.getHeaderMode(state),

    isSchemaMonitorLoading: globalReducer.getIsSchemaMonitorLoading(state),
    blueprints: viewReducer.getBlueprints(state),

    isLoading: dataSourceSummariesReducer.getIsLoading(state),
    dataSourceSummary: dataSourceSummariesReducer.getCurrentDataSourceSummary(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(OverviewViewContainer);
